export default {
  login: [
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'register for pathway to admission',
      text: 'not-sure'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'click',
      region: 'main content',
      section: 'registration',
      text: 'begin registration'
    }
  ],
  signup: [
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'registration',
      text: 'go back'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ first name',
      text: "to populate with user's entry"
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ last name',
      text: "to populate with user's entry"
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ primary email',
      text: '"to populate with user\'s entry"',
      component: 'edit profile'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'month',
      region: 'main content',
      section: 'registration',
      text: '*'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'day',
      region: 'main content',
      section: 'registration',
      text: '*'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'year',
      region: 'main content',
      section: 'registration',
      text: '*'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'dropdown',
      region: 'main content',
      section: 'registration',
      text: '*'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'click',
      region: 'main content',
      section: 'registration',
      text: 'begin registration',
      first_name: '',
      last_name: '',
      email_address: '',
      month: '',
      day: '',
      year: ''
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'submit',
      region: 'main content',
      section: 'registration',
      text: 'continue'
    }
  ],
  createLearner: [
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'welcome to earned admission',
      text: 'register now'
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'welcome to earned admission',
      text: 'login'
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'welcome to earned admission',
      text: 'what is an asurite id?'
    }
  ],
  UserInfo: [
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'register for pathway to admission',
      text: 'country code'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'country code',
      region: 'main content',
      section: 'register for pathway to admission',
      text: ''
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'register for pathway to admission',
      text: 'month'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'month',
      region: 'main content',
      section: 'register for pathway to admission',
      text: ''
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'register for pathway to admission',
      text: 'day'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'day',
      region: 'main content',
      section: 'register for pathway to admission',
      text: ''
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'register for pathway to admission',
      text: 'year'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'year',
      region: 'main content',
      section: 'register for pathway to admission',
      text: ''
    },
    {
      event: 'select',
      action: 'open',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'register for asu ea',
      text: 'gender'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'gender',
      region: 'main content',
      section: 'register for asu ea',
      text: ''
    },
    {
      event: 'select',
      action: 'open',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'register for asu ea',
      text: 'ethnicity'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'ethnicity',
      region: 'main content',
      section: 'register for asu ea',
      text: ''
    },
    {
      event: 'select',
      action: 'open',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'register for asu ea',
      text: 'household income'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'household income',
      region: 'main content',
      section: 'register for asu ea',
      text: ''
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'click',
      region: 'main content',
      section: 'registration',
      text: 'submit'
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'registration',
      text: 'go back'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ address',
      text: "to populate with user's entry"
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ city',
      text: '"to populate with user\'s entry"'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ state',
      text: '"to populate with user\'s entry"'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ zip code',
      text: '"to populate with user\'s entry"'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ country',
      text: '"to populate with user\'s entry"'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'registration ^ phone number',
      text: '"to populate with user\'s entry"'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'gender',
      region: 'main content',
      section: 'registration',
      text: '*'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'ethnicity',
      region: 'main content',
      section: 'registration',
      text: '*'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'household income',
      region: 'main content',
      section: 'registration',
      text: '*'
    },
    {
      event: 'select',
      name: 'onclick',
      action: 'click',
      type: 'checkbox',
      region: 'main content',
      section: 'registration',
      text: 'I consent to receive educational support from ASU via SMS/text messages, automated calls, and/or prerecorded voice messages at the information provided above. I also consent to ASU’s mobile terms and conditions. I recognize that message and data rates may apply.'
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'registration',
      text: "asu's privacy statement"
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'registration',
      text: 'asu european supplement'
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'registration',
      text: 'next'
    }
  ],
  Orientation: [
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: "you're all set!",
      text: 'course catalog'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'step three',
      text: 'welcome.ea.asu.edu'
    }
  ],
  SecondaryHeaderComponent: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'dashboard'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'add courses'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'course history'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'resources'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'help'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'logout'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'login'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'pathways'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'profile'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'universal learner courses'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'asu logo'
    }
  ],
  Dashboard: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'main content',
      text: 'add courses'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'event',
      region: 'main content',
      section: 'not sure what courses to take?',
      text: 'front arrow'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'be prepared for proctored exams',
      text: 'id verify and exam proctoring rules'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: '', // override params
      region: 'main content',
      section: 'when would you like to start?',
      text: '' // override params
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'my current courses',
      text: 'View your past courses'
    }
  ],
  Resources: [
    {
      event: 'collapse',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'resources',
      text: 'frequent asked questions'
    }
  ],
  MyCourses: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: '', // override params
      section: '', // override params
      text: '' // override params
    },
    {
      event: 'modal',
      action: '', // override params
      type: 'click',
      name: 'onclick',
      region: '', // override params
      section: '', // override params
      text: 'course details'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'navbar',
      section: '*placeholder*',
      text: 'options'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: '',
      text: 'view full course details'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'english composition: research and writing',
      text: 'view course results',
      component: 'past courses'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'navbar',
      section: '*placeholder*',
      text: 'warning icon'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: '*placeholder*',
      text: 'enroll and pay'
    }
  ],
  CurrentGPA: [
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'in-progress courses',
      text: 'what user select',
      component: 'current gpa'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'current GPA',
      text: 'calculate'
    }
  ],
  AddCourses: [
    {
      event: 'select',
      action: '', // override params
      name: 'onclick',
      type: '', // override params
      region: 'main content',
      section: 'course search',
      text: '' // override params
    },
    {
      event: 'search',
      action: 'type',
      type: 'course',
      name: 'onenter',
      region: 'hero',
      section: 'course search'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'my courses',
      text: 'add courses'
    }
  ],
  MobileHeader: [
    {
      event: 'collapse',
      name: 'onlick',
      type: 'click',
      region: 'navbar',
      section: 'main navbar',
      text: 'menu button mobile'
    }
  ],
  LoggedInMobileNavBar: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'dashboard'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'add courses'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'course history'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'pathways'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'profile'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'Help'
    }
  ],
  LoggedOutSecondaryheader: [
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'home'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'navbar',
      section: 'main navbar',
      text: 'how it works'
    }
  ],
  LoginSecondary: [
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'navbar',
      section: 'main navbar',
      text: 'home'
    },
    {
      event: 'link',
      action: 'click',
      type: 'internal link',
      name: 'onclick',
      region: 'navbar',
      section: 'main navbar',
      text: 'help'
    }
  ],
  FooterComponent: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'footer',
      section: 'primary footer',
      text: ''
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'footer',
      section: 'primary footer',
      text: ''
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'footer',
      section: 'primary footer',
      text: 'how it works'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'footer',
      section: 'secondary footer',
      text: 'maps and locations'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'footer',
      section: 'tertiary footer',
      text: ''
    }
  ],
  confirmRegisteration: [
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'click',
      region: 'main content',
      section: 'registration',
      text: 'submit'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'register',
      type: 'click',
      region: 'main content',
      section: 'registration',
      text: 'registration submitted'
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'registration',
      text: 'go back'
    },
    {
      event: 'link',
      name: 'onclick',
      action: 'click',
      type: 'internal link',
      region: 'main content',
      section: 'registration',
      text: 'edit'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'submit',
      region: 'main content',
      section: 'registration',
      text: 'confirm'
    }
  ],
  idVerifiyStep1: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link ',
      region: 'main content',
      section: 'what you need for verification',
      text: 'let\u2019s begin'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'take your photo',
      text: 'use my camera'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'take your photo',
      text: 'capture'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: ' internal link',
      region: 'main content',
      section: 'take your photo',
      text: 'retake'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'take your photo',
      text: 'next'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick ',
      type: 'internal link',
      region: 'main content',
      section: 'take your photo',
      text: 'read our FAQ'
    }
  ],
  idVerifiyStep3: [
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'checkbox',
      region: 'main content',
      section: 'review your photos',
      text: 'yes, my photos meet the requirements'
    },
    {
      event: 'link ',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'review your photos',
      text: 'retake your photos'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick ',
      type: 'internal link ',
      region: 'main content',
      section: 'review your photos',
      text: 'submit'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'review your photos',
      text: 'contacting our support team'
    }
  ],
  idVerifiyThankYou: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link ',
      region: 'main content',
      section: 'thank you',
      text: 'return to your dashboard'
    }
  ],
  parentConsent: [
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'checkbox',
      region: 'main content',
      section: 'parental consent required',
      text: 'I am the parent or legal guardian of the minor named above. I have the legal right to consent to an, by signing below, i hereby do consent in all respects to the terms and conditions of this course upgrade fee each are set forth in the open scale terms of uses.'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'parental consent required',
      text: 'open scale terms of use'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'parental consent required',
      text: 'first name'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'parental consent required',
      text: 'last name'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'parental consent required',
      text: 'consent and continue to payment',
      first_name: '', // override params
      last_name: '' // override params
    }
  ],
  minorConsent: [
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'checkbox',
      region: 'main content',
      section: 'parental consent',
      text: 'checkbox icon'
    },
    {
      event: 'form_submit',
      action: 'submit',
      name: 'onsubmit',
      type: 'rfi_form_submit',
      region: 'main content',
      section: 'parental consent',
      text: 'consent',
      component: 'button'
    }
  ],
  ChatUI: [
    {
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'footer',
      section: 'sticky icon',
      text: 'chatbot'
    },
    {
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'chat sidebar',
      text: 'chat icon'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'live chat',
      text: 'chat now'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'live chat ',
      text: 'ulcourses@asu.edu'
    }
  ],
  courseCheckout: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'main content',
      section: 'About Credit at ASU',
      text: 'GPA Calculator'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'checkbox',
      region: 'main content',
      section: 'Selected Course',
      text: 'I understand that this is my final grade, and it can not be changed once I transcript the course.'
    },
    {
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'selected courses',
      text: 'continue',
      component: 'cis 313 location analytics in business'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal click',
      region: 'main content',
      section: 'enroll in your course',
      text: 'return to dashboard'
    }
  ],
  appHeader: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'topbar',
      text: 'asu home'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'topbar',
      text: 'my asu'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'navbar',
      section: 'topbar',
      text: 'college and schools'
    },
    {
      event: 'search',
      action: 'type',
      name: 'onenter',
      type: 'main search',
      region: 'navbar',
      section: 'main search',
      text: 'search'
    }
  ],
  myProgress: [
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'gpa',
      text: 'estimate new gpa',
      components: 'my progress'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'pathways',
      text: 'learn more about pathways',
      components: 'my progress'
    }
  ],
  profileCompletion: [
    {
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'incomplete profile',
      text: 'incomplete profile'
    },
    {
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'incomplete profile',
      text: 'complete your profile'
    }
  ],
  idVerifyBox: [
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'not verified',
      text: 'verify your identity'
    }
  ],
  ecommerceTags: [
    {
      event: 'remove_from_cart',
      ecommerce: {}
    }
  ],
  completeYourProfileModal: [
    {
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: '',
      text: 'close cross',
      component: 'complete your profile'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'complete your profile',
      //to populate with what user selects
      text: ''
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: '',
      text: 'next',
      component: 'complete your profile'
    },
    //When user selects:
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'checkbox',
      region: 'main content',
      section: '',
      //to populate with what user selects
      text: ''
    },
    //When user unselects:
    {
      event: 'select',
      action: 'unclick',
      name: 'onclick',
      type: 'checkbox',
      region: 'main content',
      section: '',
      //to populate with what user selects
      text: ''
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: '',
      text: 'previous',
      component: 'complete your profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'complete your profile',
      text: 'submit'
    },
    // On successful submission
    {
      event: 'form',
      action: 'form_submit',
      name: 'onsubmit',
      type: 'submit',
      region: 'main content',
      section: 'complete your profile',
      text: 'form submitted'
    },
    {
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'complete your profile',
      text: 'close'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: '',
      //When user selects:
      text: '',
      component: 'complete your profile'
    },
    {
      event: 'select',
      action: 'unclick',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: '',
      //When user selects:
      text: '',
      component: 'complete your profile'
    }
  ],
  editProfileModal: [
    {
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'edit profile',
      text: 'close cross'
    },

    {
      event: 'form',
      action: 'form submit',
      name: 'onsubmit',
      type: 'submit',
      region: 'main content',
      section: 'edit profile',
      text: 'form submitted',
      first_name: '',
      last_name: '',
      email: '',
      phone: ''
    },
    {
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'my profile',
      text: 'edit profile'
    },
    {
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'basic information',
      text: 'request name change',
      component: 'edit profile'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ preferred name',
      text: "to populate with user's entry",
      component: 'edit profile'
    },
    {
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'request name change',
      text: 'back to edit profile'
    },
    {
      event: 'form_submit',
      action: 'submit',
      name: 'onsubmit',
      type: 'request form submit',
      region: 'main content',
      section: 'request name change',
      text: 'submit request'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'checkbox',
      region: 'main content',
      section: 'basic information ^ notifications email',
      text: 'same as primary email',
      component: 'edit profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ address',
      text: 'to populate what user types',
      component: 'edit profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ city',
      text: 'to populate what user types',
      component: 'edit profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ state',
      text: 'to populate what user types',
      component: 'edit profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ zipcode',
      text: 'to populate what user types',
      component: 'edit profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ country',
      text: 'to populate what user types',
      component: 'edit profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'blur',
      region: 'main content',
      section: 'basic information ^ phone',
      text: 'to populate what user types',
      component: 'edit profile'
    },
    {
      event: 'form',
      action: 'click',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'educational information ^ high school',
      text: 'to populate what user types',
      component: 'edit profile'
    },
    {
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'educational information',
      text: 'to populate what user selects',
      component: 'edit profile'
    }
  ],
  requestNameChangeModal: [
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'request name change ^ first name',
      text: "to populate with user's entry",
      component: 'request name change'
    },
    {
      event: 'form',
      name: 'onclick',
      action: 'click',
      type: 'blur',
      region: 'main content',
      section: 'request name change ^ last name',
      text: "to populate with user's entry",
      component: 'request name change'
    }
  ],
  myCoursesGPAImpactModal: [
    {
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'gpa impact alert',
      text: 'close cross',
      component: 'high school and ulc learners'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'gpa impact alert',
      text: 'calculate gpa',
      component: 'high school and ulc learners'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'gpa impact alert',
      text: 'contact a success coach here',
      component: 'high school and ulc learners'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'gpa impact alert',
      text: 'yes, add to transcript',
      component: 'high school and ulc learners'
    },
    {
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'gpa impact alert',
      text: 'cancel',
      component: 'high school and ulc learners'
    },
    {
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'gpa requirement alert',
      text: 'calculate gpa',
      component: 'earned admission and pathway to admission'
    }
  ],
  PathwayRecommendationCard: [
    {
      // 0 - Enroll in pathway button click
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal',
      region: 'main content',
      section: 'pathways',
      text: 'register in pathway'
    },
    {
      // 1 - View details button click (opens sidebar)
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'pathways',
      text: 'view details'
    }
  ],
  EnrolledPathwayCard: [
    {
      // 0 - Unenroll/Remove pathway button click
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'pathways',
      text: 'remove pathway'
    },
    {
      // 1 - View details button click
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'main content',
      section: 'pathways',
      text: 'view details'
    },
    {
      // 2 - View all recommended courses toggle
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'pathways',
      text: 'view all recommended courses'
    },
    {
      // 3 - View all required courses toggle
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'pathways',
      text: 'view all required courses'
    }
  ],
  CourseDesignationCard: [
    {
      // 0 - Search courses button click
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'main content',
      section: 'pathways',
      text: 'search courses'
    }
  ],
  PathwayDetailsSidebar: [
    {
      // 0 - Enroll in pathway button click
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external',
      region: 'main content',
      section: 'pathways',
      text: 'register in pathway'
    },
    {
      // 1 - View all courses toggle
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'pathways',
      text: 'view all'
    }
  ],
  PathwayDetailPage: [
    {
      // 0 - Click degree row in catalog (dynamic text)
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'pathways',
      text: '' // override with degree name
    }
  ],
  PathwaysPage: [
    {
      // 0 - Click pathway category card (dynamic text)
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'main content',
      section: 'pathways',
      text: '' // override with pathway title
    }
  ],
  accelerateDashboard: [
    {
      // 0
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'welcome',
      text: 'notifications',
      component: 'icon'
    },
    {
      // 1
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'verify your id',
      text: 'get started',
      component: 'button'
    },
    {
      // 2
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: "let's get started with signing up for courses",
      text: 'sign up for courses',
      component: 'button'
    },
    {
      // 3
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'month',
      region: 'main content',
      section: 'when do you expect to graduate from high school',
      text: 'to populate with what user selects',
      component: 'dropdown'
    },
    {
      // 4
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'when do you expect to graduate from high school',
      text: 'set',
      component: 'button'
    },
    {
      // 5
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'have questions',
      text: 'contact_email',
      component: 'text'
    },
    {
      // 6
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'have questions',
      text: 'live chat',
      component: 'text'
    },
    {
      // 7
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'essential financial tools',
      text: 'populate with the title text', // financial wellness title text
      component: 'text'
    },
    {
      // 8
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'stay engaged with asu',
      text: 'view more',
      component: 'text'
    },
    {
      // 9
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'main content',
      section: 'additional resources',
      text: 'faqs', // populate resources text
      component: 'button'
    },
    {
      // 10
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'credit progress', // populate degrees or certificates
      text: 'see details', // populate degrees or certificates text
      component: 'degrees certificates'
    },
    {
      // 11
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'credit progress', // populate degrees or certificates
      text: 'degrees', // populate degrees or certificates text
      component: 'progress tracker'
    },
    {
      // 12
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'credit progress',
      text: 'access my courses',
      component: 'button'
    },
    {
      // 13
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'my college credits',
      text: 'access my courses',
      component: 'button'
    },
    {
      // 14
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'my college credits',
      text: 'see my full learning history',
      component: 'text'
    },
    {
      // 15
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'my college credits',
      text: 'verified asu credits', // populate college credits tooltip text
      component: 'tool tip'
    },
    {
      // 16
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'my college credits',
      text: 'verified asu credits', // populate college credits tooltip text
      component: 'tool tip'
    },
    {
      // 17
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'associate degree progress', // populate associate or degrees modal tooltip section
      text: 'verified asu credits', // populate associate or degrees modal tooltip text
      component: 'tool tip'
    },
    {
      // 18
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'associate degree progress', // populate associate or degrees modal tooltip section
      text: 'verified asu credits', // populate associate or degrees modal tooltip text
      component: 'tool tip'
    },
    {
      // 19
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'carousel',
      region: 'main content',
      section: 'degree progress section',
      text: 'left chevron' // populate degree progress chevron text
    },
    {
      // 20
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'degree progress section',
      text: 'close cross'
    },
    {
      // 21
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'sticky navbar',
      text: 'progress' // update text on stickynavbar
    },
    {
      // 22
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'dropdown',
      region: 'main content',
      section: 'certificates',
      text: 'sort by' // populate with sort by text
    },
    {
      // 23
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'financial wellness for college',
      section: 'your estimated savings',
      text: 'typical asu tuition'
    },
    {
      // 24
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'external link',
      region: 'main navbar',
      section: 'feedback banner',
      text: 'provide feedback'
    },
    {
      // 25
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'bachelor degree progress',
      text: 'general requirements'
    },
    {
      // 26
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'carousel',
      region: 'main content',
      section: 'credit progress',
      text: 'semester' // populate with sort by text
    },
    {
      // 27
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'credit progress',
      text: 'info icon', // populate college credits tooltip text
      component: 'tool tip'
    },
    {
      // 28
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'credit progress',
      text: 'info icon', // populate college credits tooltip text
      component: 'tool tip'
    },
    {
      // 29
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'session information',
      text: 'view more important dates',
      component: 'session full width toast'
    },
    {
      // 30
      event: 'modal',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'session information',
      text: 'close cross',
      component: 'session full width toast'
    },
    {
      // 31
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'welcome',
      text: 'notifications',
      component: 'icon'
    },
    {
      // 32
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'credit progress',
      text: 'calculate gpa'
    },
    {
      // 33
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'credit progress',
      text: 'verified asu credits',
      component: 'tool tip'
    },
    {
      // 34
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'carousel',
      region: 'main content',
      section: 'dates to remember',
      text: 'back arrow',
      component: 'icon'
    },
    {
      // 35
      event: 'select',
      action: 'click',
      name: 'onclick',
      type: 'carousel',
      region: 'main content',
      section: 'dates to remember',
      text: 'forward arrow',
      component: 'icon'
    },
    {
      // 36
      event: 'link',
      action: 'click',
      name: 'onclick',
      type: 'internal link',
      region: 'main content',
      section: 'dates to remember',
      text: 'add courses'
    },
    {
      // 37
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'notification',
      text: 'back',
      component: 'notification side panel'
    },
    {
      // 38
      event: 'modal',
      action: 'open',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'notification',
      text: 'expand icon',
      component: 'notification side panel'
    },
    {
      // 39
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'notification',
      text: 'back',
      component: 'notification full panel'
    },
    {
      // 40
      event: 'collapse',
      action: 'close',
      name: 'onclick',
      type: 'click',
      region: 'main content',
      section: 'notification',
      text: 'minimize icon',
      component: 'notification full panel'
    }
  ]
};
